<template>
  <header>
    <nav
      class="navbar is-primary"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="container">
        <div class="navbar-brand">
          <router-link class="navbar-item" :to="{ path: '/' }">
            <b>{{ $t("commons.programName") }}</b>
          </router-link>
          <a
            role="button"
            class="navbar-burger burger"
            aria-label="menu"
            :aria-expanded="expanded"
            @click.stop="toggle"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div class="navbar-menu" :class="{ 'is-active': expanded }">
          <div class="navbar-start">
            <router-link
              class="navbar-item"
              :to="{ path: '/download' }"
              @click.native="expanded = false"
            >
              {{ $t("menu.download") }}
            </router-link>
            <router-link
              class="navbar-item"
              :to="{ path: '/tutorials' }"
              @click.native="expanded = false"
            >
              {{ $t("menu.tutorial") }}
            </router-link>
            <router-link
              class="navbar-item"
              :to="{ path: '/documentation' }"
              @click.native="expanded = false"
            >
              {{ $t("menu.documentation") }}
            </router-link>
            <router-link
              class="navbar-item navbar-item--news"
              :to="{ path: '/', query: { section: 'novedades' } }"
              @click.native="expanded = false"
            >
              {{ $t("menu.news") }}
            </router-link>
            <router-link
              class="navbar-item"
              :to="{ path: '/contact' }"
              @click.native="expanded = false"
            >
              {{ $t("menu.contact") }}
            </router-link>
          </div>
          <div class="navbar-end">
            <LanguageSelector />
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import LanguageSelector from "@/components/LanguageSelector.vue";

export default {
  components: {
    LanguageSelector,
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
